module.exports = "/static/images/BCT-logo-full--2.svg";